import React from "react";
import ReactDOM from "react-dom";
import "./App.css";
import "./Ant.css";
import "./Helper/NotifStyle.css";
import "react-toastify/dist/ReactToastify.css";
import "@hassanmojab/react-modern-calendar-datepicker/lib/DatePicker.css";
import App from "./App";
import { Provider } from "react-redux";
import { thunk } from "redux-thunk";
import { createStore, combineReducers, applyMiddleware } from "redux";
import { BrowserRouter as Router } from "react-router-dom";
import PannelReducer from "./Redux/Reducers/PannelReducer";
import AuthReducer from "./Redux/Reducers/AuthReducer";
import TechAppReducer from "./Redux/Reducers/TechAppReducer";
import { AuthProvider } from "./Api/authReq";
import { TechappProvider } from "./Api/techappReq";
import { ToastContainer } from "react-toastify";
import * as serviceWorkerRegistration from "./serviceWorkerRegistration";

const rootReducer = combineReducers({
  PannelReducer: PannelReducer,
  TechAppReducer: TechAppReducer,
  AuthReducer: AuthReducer,
});

const store = createStore(rootReducer, applyMiddleware(thunk));

ReactDOM.render(
  <Router>
    <Provider store={store}>
      <AuthProvider>
        <TechappProvider>
          <ToastContainer
            position={"top-left"}
            rtl
            autoClose={6000}
            pauseOnFocusLoss={false}
          />
          <App />
        </TechappProvider>
      </AuthProvider>
    </Provider>
  </Router>,
  document.getElementById("root")
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA
serviceWorkerRegistration.register();
